import { Fragment, useEffect, useState } from "react"
import useRole from "../../hook/useRole"
import Skeleton from "react-loading-skeleton"
import { Navigate } from "react-router-dom"


export default function SuperUserLayout({children}) {

    const { hasrole } = useRole('rsosuperuser')

    const [issuperuser, setIssuperuser] = useState(null)

    useEffect(() => {
        if (hasrole !== null) {
            setIssuperuser(hasrole)
        }
    }, [hasrole])
    if (issuperuser === null) {
        return <Skeleton count={50} />
    }

    if (issuperuser === false) {
        return <Navigate to='/401' />
    }

    return <Fragment>
        {children}
    </Fragment>
}